import GoogleLoginButton, { googleLoginEnabled } from './GoogleLoginButton';
import AppleLoginButton, { appleLoginEnabled } from './AppleLoginButton';
import { AppleCredential } from '../connector/auth';
import { nativePlatform } from '../utils/platform';
import './ExternalLoginButtons.css';

// Whether any sign-in button of another provider shows, and whether the buttons come before the email
// form. The apps lead with them, each with its platform's own provider first (iOS: Apple, Android:
// Google). The website shows them after the form, side by side when there's room.
export const hasExternalLogin = googleLoginEnabled || appleLoginEnabled;
export const externalLoginFirst = !!nativePlatform;

interface ExternalLoginButtonsProps {
  verb: 'Sign in' | 'Sign up';
  onGoogle: (credential: string) => void;
  onApple: (credential: AppleCredential) => void;
  onError: (error: string) => void;
}

const ExternalLoginButtons: React.FC<ExternalLoginButtonsProps> = ({ verb, onGoogle, onApple, onError }) => {
  const appleFirst = nativePlatform == 'ios';
  // Side by side (website), the keyboard reaches the second button with left/right, like tab buttons:
  // up/down skip it. Stacked (apps), both are in the up/down flow.
  const secondSideway = !nativePlatform && googleLoginEnabled && appleLoginEnabled;
  const google = <GoogleLoginButton key='google' onSuccess={onGoogle} onError={onError} label={`${verb} with Google`} sideway={secondSideway && appleFirst} />;
  const apple = <AppleLoginButton key='apple' onSuccess={onApple} onError={onError} label={`${verb} with Apple`} sideway={secondSideway && !appleFirst} />;
  return (
    <div className={`externalLoginButtons ${nativePlatform ? 'stacked' : 'sideBySide'}`}>
      {appleFirst ? [apple, google] : [google, apple]}
    </div>
  );
};

export default ExternalLoginButtons;
